// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__qXV-p","checkbox":"Checkbox_checkbox__KLwbX","label":"Checkbox_label__W6OKD"};